import React from "react";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import Background from "shared/assets/images/svg/location.svg";

import { AddressTypes, useAddress } from "customer/settings/address/address.service";

import NewAddress from "customer/settings/address/new-address/newAddress";
import AddressGrid from "customer/settings/address/address-grid";

function CustomerAddress() {
  const { totalCount,isAddingAddress,openNewAddressDialog,closeNewAddressDialog ,addAddress} = useAddress(AddressTypes.Customer);

  return (
    <div className="settingHome myCustomers">
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>My Customers</h1>
          </div>
          <div className="info">
            <button className="btn-border-green" onClick={openNewAddressDialog}>+ Add New</button>
          </div>
        </div>
        <hr className="hr" />

        {totalCount <= 0 ? (
          <div className="row">
            <div className="col-lg-5 text-center mx-auto">
              <div className="noData">
                <img src={Background} alt="background" />
                <p>
                  Defining your customers' addresses in advance makes the ordering process very easy
                </p>
              </div>
            </div>
          </div>
        ) : (
          <AddressGrid addressType={AddressTypes.Customer} />
        )}
      </div>
      <NewAddress show={isAddingAddress} onHide={closeNewAddressDialog} addressType={AddressTypes.Customer} onSubmit={addAddress} />
    </div>
  );
}

export default CustomerAddress;
